// Generated types for AttachedRecord
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from './scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from './scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface AttachedRecordReadAPI extends ScopedNodeReadAPI {
}

export interface AttachedRecordWriteAPI extends ScopedNodeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const AttachedRecordReadAPISchemaObject = ScopedNodeReadAPISchemaObject.extend({}).passthrough();
export const AttachedRecordReadAPISchema: z.ZodType<AttachedRecordReadAPI> = AttachedRecordReadAPISchemaObject;

export const AttachedRecordWriteAPISchemaObject = ScopedNodeWriteAPISchemaObject.extend({}).passthrough();
export const AttachedRecordWriteAPISchema: z.ZodType<AttachedRecordWriteAPI> = AttachedRecordWriteAPISchemaObject;
